mutation EntityDocumentRetireBalancePersonalPool(
  $input: EntityDocumentRetireBalanceInput!
) {
  entityDocumentRetireBalance(input: $input) {
    approvalEntityDocument {
      id
    }
  }
}
